import type { AtoAprovado, AtoAprovadoListResponse, AtosFilterParams } from '../../types/atosAdministrativos';

const ATOS_API_URL = import.meta.env.VITE_ATOS_API_URL || '';

if (!ATOS_API_URL) {
  console.warn('[AtosAdmin] VITE_ATOS_API_URL não está definida. Reinicie o servidor de desenvolvimento após configurar o .env.');
}

export async function fetchAtosAprovados(params: AtosFilterParams = {}): Promise<AtoAprovadoListResponse> {
  if (!ATOS_API_URL) {
    throw new Error('URL da API de atos administrativos não configurada. Verifique a variável VITE_ATOS_API_URL no .env e reinicie o servidor.');
  }
  const searchParams = new URLSearchParams();

  if (params.q) searchParams.set('q', params.q);
  if (params.nome_ato) searchParams.set('nome_ato', params.nome_ato);
  if (params.conteudo) searchParams.set('conteudo', params.conteudo);
  searchParams.set('limit', String(params.limit ?? 12));
  searchParams.set('offset', String(params.offset ?? 0));

  const response = await fetch(`${ATOS_API_URL}/public/atos/aprovados?${searchParams}`);

  if (!response.ok) {
    if (response.status === 429) {
      throw new Error('Limite de requisições excedido. Aguarde alguns segundos e tente novamente.');
    }
    throw new Error('Erro ao buscar atos administrativos.');
  }

  return response.json();
}

export async function fetchAtoAprovadoById(atoId: number): Promise<AtoAprovado> {
  const response = await fetch(`${ATOS_API_URL}/public/atos/aprovados/${atoId}`);

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Ato administrativo não encontrado.');
    }
    throw new Error('Erro ao buscar detalhes do ato administrativo.');
  }

  return response.json();
}
